import { render, staticRenderFns } from "./Forwarder.vue?vue&type=template&id=3f1518f4&scoped=true&"
import script from "./Forwarder.vue?vue&type=script&lang=js&"
export * from "./Forwarder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1518f4",
  null
  
)

export default component.exports